import React from 'react';
import './ConfidenceChip.css';

const ConfidenceChip = ({ confidence, size = 'medium' }) => {
  const getConfidenceData = (level) => {
    const data = {
      high: { label: 'HIGH', color: '#00ff88', glow: '0 0 10px rgba(0, 255, 136, 0.5)' },
      medium: { label: 'MED', color: '#ffaa00', glow: '0 0 10px rgba(255, 170, 0, 0.5)' },
      low: { label: 'LOW', color: '#ff4444', glow: '0 0 10px rgba(255, 68, 68, 0.5)' }
    };
    return data[level] || data.medium;
  };

  const confidenceData = getConfidenceData(confidence);

  return (
    <span 
      className={`confidence-chip ${size}`}
      style={{ 
        backgroundColor: confidenceData.color,
        boxShadow: confidenceData.glow
      }}
    >
      {confidenceData.label}
    </span>
  );
};

export default ConfidenceChip;
